var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-main",
    [
      _c("div", { staticClass: "login-background" }, [
        _c(
          "video",
          {
            attrs: {
              autoplay: "",
              loop: "",
              muted: "",
              poster: require("@/assets/img/3.png"),
            },
            domProps: { muted: true },
          },
          [
            _c("source", {
              attrs: {
                src: "https://d2bt60lg5oycgc.cloudfront.net/30/driblab-login-intro-video.mp4",
                type: "video/mp4",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "fill-height pt-10", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { staticStyle: { "z-index": "1" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex flex-column align-center justify-center",
                  attrs: { cols: "12" },
                },
                [
                  _c("v-img", {
                    staticClass: "white--text my-10",
                    attrs: {
                      "max-width": "300px",
                      src: require("@/assets/img/driblab_white_box_pro.png"),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "MaterialCard",
                    {
                      staticClass: "mt-10",
                      attrs: {
                        color: _vm.$vuetify.theme.dark
                          ? "secondary"
                          : "brandDark",
                        width: "450px",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "heading",
                          fn: function () {
                            return [
                              _c(
                                "h2",
                                {
                                  staticClass: "white--text header-font",
                                  attrs: { align: "center" },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.resetPassword")))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-form",
                            {
                              ref: "formRef",
                              attrs: { name: "form" },
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onSaveClick.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text pb-1 mb-0",
                                    },
                                    [_vm._v(_vm._s(_vm.$t("login.password")))]
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    ref: "passwordRef",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      rules: _vm.passwordRules,
                                      type: "password",
                                      "prepend-inner-icon": "lock",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onInputChange()
                                      },
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.onSaveClick()
                                      },
                                    },
                                    model: {
                                      value: _vm.user.password,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.user, "password", $$v)
                                      },
                                      expression: "user.password",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text pb-1 mb-0",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("login.passwordConfirmation")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    ref: "passwordConfirmationRef",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      rules: _vm.passwordConfirmationRules,
                                      type: "password",
                                      "prepend-inner-icon": "lock",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onInputChange()
                                      },
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.onSaveClick()
                                      },
                                    },
                                    model: {
                                      value: _vm.user.passwordConfirmation,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.user,
                                          "passwordConfirmation",
                                          $$v
                                        )
                                      },
                                      expression: "user.passwordConfirmation",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                { staticClass: "justify-center px-0 pb-1" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "elevation-0 monospace-font white--text",
                                      attrs: {
                                        type: "submit",
                                        rounded: "",
                                        loading: _vm.loading,
                                        color: _vm.$vuetify.theme.dark
                                          ? "secondary"
                                          : "brandBlue",
                                        block: "",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("general.save")))]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }